import { render, staticRenderFns } from "./ProductDeptsComponent.vue?vue&type=template&id=2077dbe7&scoped=true"
import script from "./ProductDeptsComponent.vue?vue&type=script&lang=js"
export * from "./ProductDeptsComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductDeptsComponent.vue?vue&type=style&index=0&id=2077dbe7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2077dbe7",
  null
  
)

export default component.exports